import { PlainModalContent } from 'app/common/ui-next/plain-modal'
import OrgsDataProvider from 'app/dataProviders/org/OrgsDataProvider'
import { Tabs, Tab, TabPanels, TabPanel } from 'app/common/ui/PlainTabs'
import type { OrgItem } from 'app/common/api/requests/food/schools'
import * as orgsTypes from 'app/common/constants/schools/types'

import { CopyKitFormOtherOrgs } from './CopyKitFormOtherOrgs'
import styles from './CopySortKit.module.scss'
import { OrgId } from 'app/common/types/id'

const orgsFilterCb = (item: OrgItem): boolean => {
  const { cafeteria_enabled: cafeteriaEnabled, type, deleted, approved } = item
  const actual = !deleted && approved
  if (type === orgsTypes.ENTERPRISE) return actual && cafeteriaEnabled
  return actual
}

type Props = {
  orgId: OrgId
  onSelectedOrgs: (orgs: Array<string>) => void
  disabled: boolean
}

export const CopySortKit = ({ orgId, disabled, onSelectedOrgs }: Props) => {
  const orgID = parseInt(orgId, 10)

  return (
    <div className={styles.root}>
      <div className={styles.orgs}>
        <OrgsDataProvider orgId={orgID} filterCb={orgsFilterCb} sameType>
          <div>
            <Tabs value={1} onChange={() => {}}>
              <Tab index={1}>{'В другие заведения'}</Tab>
            </Tabs>

            <TabPanels value={1} className={styles.panels} unmountHidden>
              <TabPanel index={1}>
                <CopyKitFormOtherOrgs
                  orgIdFrom={orgId}
                  disabled={disabled}
                  onChangeOrgsSelected={onSelectedOrgs}
                  // onChangeDateTo={setDateTo}
                  // errors={errors}
                  resetErrors={() => {}}
                />
              </TabPanel>
            </TabPanels>
          </div>
        </OrgsDataProvider>
      </div>
      <PlainModalContent borderTop className={styles.info}>
        {
          'Копирование настроек займет продолжительное время. Новые настройки вступят в силу в течениии от нескольких минут до нескольких часов, в зависимости от количества заведений'
        }
      </PlainModalContent>
    </div>
  )
}
